import Span from '../common/textElements/Span.tsx'
import { cn } from '@/lib/utils.ts'
import { TextVariantT } from '@/components/common/textElements/Paragraph.tsx'

type PropsT = {
  quantity: number | string
  variant?: 'light' | 'dark' | 'muted'
  className?: string
}

export default function Count({ quantity, variant = 'dark', className }: PropsT) {
  let textVariant: TextVariantT = 'default'

  switch (variant) {
    case 'dark':
      textVariant = 'primaryForeground'
      break
    case 'muted':
      textVariant = 'muted'
      break
    default:
      textVariant = 'default'
      break
  }

  return (
    <div
      className={cn(
        `ml-auto flex h-[1.125rem] min-w-[1.125rem] items-center justify-center rounded-full bg-border px-1.5`,
        variant === 'dark' && 'bg-muted-foreground',
        className,
      )}
    >
      <Span
        className={`shrink-0 grow-0 font-medium leading-none`}
        size={'xxs'}
        variant={textVariant}
        text={quantity}
      />
    </div>
  )
}
